import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import CKEditor from './CKEditorControl';


const HtmlEditor = ({ horizontal, required, lang, height, input: { onChange, value }, label, type, help, disabled, onInstanceReady, tagsEnabled, tagAllGroups, applicableGroups, comboLabel, meta: { touched, error, warning }, children, ...props }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	const formControl = <CKEditor content={value} onChange={onChange} disabled={disabled} lang={lang} height={height} onInstanceReady={onInstanceReady}
		tagsEnabled={tagsEnabled} tagAllGroups={tagAllGroups} applicableGroups={applicableGroups} comboLabel={comboLabel}>{children}</CKEditor>;

	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em className='required_s'>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState}>
				<Col componentClass={ControlLabel} sm={2}>
					{label}{labelHint}
				</Col>
				<Col sm={10}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			{label && <ControlLabel>{label}{labelHint}</ControlLabel>}
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

HtmlEditor.propTypes = {
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	type: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	componentClass: PropTypes.string,
	value: PropTypes.string,
	icon: PropTypes.string,
	lang: PropTypes.string
};

export default HtmlEditor;